<template>
    <div id="step_component_wrapper">
      <div class="slot-content" style="padding-left: 150px;">
        <div class="input-group">

            <div class="radio">
              <label>
                <input type="radio" v-model="choice" id="machine_check"  value="machineClicked">
               {{labels[1]}}
                <input class="form-control" id="model_selector" name="model" type="text" :disabled="!machineClicked"
                v-model="machineValue" :placeholder="labels[0]" 
                style=" margin: 10px 0px 25px 5px; border-radius: 2px; padding: 0px 10px; margin">
              </label>
            </div>
            <div class="radio">
              <label>
                <input type="radio" v-model="choice" id="index_check"  value="indexClicked">
                {{labels[2]}}
              </label>
            </div>

        </div>
      </div>
        <div  class="slot-button">
            <button  class="btn btn-danger" @click="$root.logout()">{{$Jed.firstUpperTranslate('logout', null)}}</button>

            <button class="btn btn-primary-default" @click="forward" style="width: auto;" :disabled="(!machineClicked && !indexClicked) || forwarding">
                {{$Jed.firstUpperTranslate('confirm', null)}}
            </button>

        </div>
    </div>  
</template>
<script>
import { eventBus } from "../../../eventbus.js";
export default {
  props: {
    backTo1Allowed: {
      type: Boolean,
      default: false
    },
    isAfterLogin: {
      type: Boolean,
      default: false
    },
    exOnOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function(){
    return {
      showModels: false,
      choice: "machineClicked",
      machineClicked: true,
      indexClicked: false,
      machineValue: "",
      labels: [
        this.$Jed.firstUpperTranslate('insert %1$s', null, {key: 'machine ID'}) + (this.$Behaviors.catalogSelection ? (this.$Behaviors.catalogSelection.snRequestedChars ? ' ('+this.$Behaviors.catalogSelection.snRequestedChars+' '+this.$Jed.translate("digits")+')' : '') : ""),
        this.$Jed.firstUpperTranslate('machine catalog', null),
        this.$Jed.firstUpperTranslate('sector catalog', null)
      ],
      machineValid: true,
      machineErrorIndex: 1,
      machinePlaceholder: [
        this.$Jed.firstUpperTranslate("incorrect %1$s format", null, {
          key: "machine ID"
        }),
        this.$Jed.firstUpperTranslate("machine not found: see sector catalog", null, {
          key: "machine ID"
        })
      ],
      forwarding: false,
      checkSnFormat: this.$Behaviors.catalogSelection ? this.$Behaviors.catalogSelection.snTotalChars && this.$Behaviors.catalogSelection.snPrefix && this.$Behaviors.catalogSelection.snRequestedChars : false
    }
  },
  watch: {
    choice: function(){
      this.machineClicked = false;
      this.indexClicked = false;
      if(this[this.choice] == false){
        this[this.choice] = true;
      }
    },
    machineClicked: function(){
      this.machineValue = "";
    }
  },
  methods: {
      async forward(){
        if(this.machineClicked){
          //se è definito un behaviour per la validazione della matricola
          if(this.$Behaviors.machineIdValidationExp && this.$Behaviors.machineIdValidationExp != ""){
            try {
              var regExp_Matricola = new RegExp(this.$Behaviors.machineIdValidationExp);
              this.machineValid = regExp_Matricola.test(this.machineValue);
            } catch (err) {
              console.log("Parsing machineValue with RegExp");
              console.log(err);
              this.machineValid = false;
            }
          }
          //se sono definiti i behaviour per il formato della matricola
          if(this.checkSnFormat){
            if(this.machineValue.length == this.$Behaviors.catalogSelection.snRequestedChars){
              this.machineValid = true
            }else{
              this.machineValue = null;
              this.machineValid = false;
              this.machineErrorIndex = 0;
            }
          }
          //se la matricola è valida
          if(this.machineValid){
            var nodes_c = this.$root.dbModels.getCollection('nodes'),
                node,
                machine_id;

            if(this.checkSnFormat){
              var diff = this.$Behaviors.catalogSelection.snTotalChars - this.machineValue.length 
              var pref = this.$Behaviors.catalogSelection.snPrefix.repeat(diff);
              machine_id = pref+this.machineValue
            }else{
              machine_id = this.machineValue
            }

            console.log("waiting fetch machine...")

            this.forwarding = true;
            var machine = await this.$root.fetchRegistryData("machines", "GetMachines", "recordset", {"id": machine_id})
            this.forwarding = false;

            console.log("fetch returned: machine - ", machine)

            if(machine && machine.length > 0){
              machine = machine[0]
              // 2) controllo nella collezione dei modelli che ci sia un nodo relativo al prodotto associato alla matricola 
              node = nodes_c.find({"sid": machine.pid});

              var isVisible = false,
              idVisibleCat;
              //filtrare per cataloghi visibili dal cliente (il primo visibile dal cliente)
              this.$Configs.catalogs.some((c)=>{
                return isVisible = node.some((n)=>{
                  if(n.cac == c.id){
                    console.log('n.cac: ', n.cac)
                    console.log('id catalogo: ', c.id)
                    idVisibleCat = n.cac
                    return n.cac
                  }
                })
              })
              console.log('idVisibleCat: ', idVisibleCat)
              if(isVisible){
                if(node && node.length > 0){
                  var visibleMachine = node.find(n=>{
                    return n.cac == idVisibleCat
                  }); 
                  console.log('visibleMachine: ', visibleMachine)
                  
                  this.$root.validity = machine_id;

                  this.$root.catalog_icon = this.$root.icons.left;
                  // 3) se ogni ricerca va a buon fine, carico il modello associato alla matricola, passando anche il riferimento alla categoria (necessaria per caricare il modello come root)
                  this.load(visibleMachine.fid, visibleMachine.sid, visibleMachine.cac);
                } else {
                  console.log('modello non trovato per la matricola :', machine.pid)
                  this.machineValue = null;
                  this.machineValid = false;
                  this.machineErrorIndex = 1;
              
                  var parameters = {};
                  parameters.functionName = "load_from_client_catalog_list";
                  parameters.functionParameter = true;
                  this.$emit('forward', parameters);
                }
              }else{
                this.$root.simpleNotification("error", {
                  title: "",
                  message: 'machine '+ machine.id +' is in a catalog not visible to client ' + this.$Configs.idCliente,
                })
              }
            } else {
              console.log('matricola ', machine_id, ' non trovata nel registry')
              this.machineValue = null;
              this.machineValid = false;
              this.machineErrorIndex = 1;
            
              var parameters = {};
              parameters.functionName = "load_from_client_catalog_list";
              parameters.functionParameter = true;
              this.$emit('forward', parameters);
            }
          }else{
            this.machineValue = null;
            this.machineValid = false;
            this.machineErrorIndex = 0;
          }

          if(!this.machineValid){
            if(this.$Behaviors.catalogSelection.snWarning == 'simple'){
              this.$root.simpleNotification("error", {
                title: "",
                message: this.machinePlaceholder[this.machineErrorIndex],
              })
            }else if(this.$Behaviors.catalogSelection.snWarning == 'window'){
              var e = {
                icon: "warning",
                title: this.$Jed.firstUpperTranslate('warning'),
                message: this.machinePlaceholder[this.machineErrorIndex],
                ok: function(){
                  this.close();
                },
                YtxtBtn: this.$Jed.firstUpperTranslate('Ok')
              }
              eventBus.$emit("confirm", e)
            }
          }

        }else {
          this.$root.catalog_icon = this.$root.icons.info
          var parameters = {};
          parameters.functionName = "load_from_client_catalog_list";
          parameters.functionParameter = true;
          this.$emit('forward', parameters);
        }
      },
      
      load: function(cat, mod, idCat){
        eventBus.$emit('closePurchasePopup', null)
        var parameters = {},
            catalogs = this.$root.dataReferences.getCollection("catalogs"),
            catalogo = catalogs.find({
              id: idCat
            })[0]

        if(catalogo){
          if(catalogo.brand){
            this.$root
            .microservice({
                role: "authentication",
                cmd: "GetBrand",
                params: {
                    brandCod: catalogo.brand
                }
            })
            .then(response => {   
              //salvo le info del brand in brandObj ma se ricarico la pagina perdo le info quindi le salvo anche nel localStorage 
              this.$root.brandObj = response ? response.body : {}
              if(response && response.body)localStorage.setItem('brand', JSON.stringify(response.body))
              //this.$root.setCustomCss();
            })
            .catch(err => {
              console.log(err);
              var msg = err && err.body && err.body.error ? err.body.error : ''
              eventBus.$emit('alert', {
                message: "Application caught an error <br> <h5>Details: " + "authentication.GetBrand - " + msg +'</h5>',
                type: "error",
                action: ''
              })
            })
          }else{
            this.$root.simpleNotification("error", {
              title: "",
              message: 'missing brand on catalog: '+idCat,
            })
          }
        }else{
          this.$root.simpleNotification("error", {
            title: "",
            message: 'catalog ' + idCat + ' is not published, or it is not assigned to client ' + this.$Configs.idCliente,
          })
        }

        parameters.functionName = "load";

        if(catalogo){
          if (this.machineValue != null && cat && mod && idCat) {
            parameters.override = {modello: mod, categoria: cat, catalogo: idCat, fileName: catalogo.file}
          }else if(this.machineValue==null || this.machineValue=="" && idCat){
            parameters.override = { catalogo: catalogo.id, nomeCatalogo: catalogo.name, modello: null, categoria: null, fileName: catalogo.file, descrizioneModello: null };
          }
        }else{
          this.$root.simpleNotification("error", {
            title: "",
            message: 'catalog missing: '+idCat,
          })
        }

        this.$emit("forward", parameters);
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/loader/steps/PreSelezione.vue?4fdc69de